import { useState, useCallback } from "react";
import { cards } from "./terminalData";

export default function useModals() {
  const [openEbookModal, setOpenEbookModal] = useState(false);
  const [openGetDemoModal, setOpenGetDemoModal] = useState(false);
  const [openCalendlyModal, setOpenCalendlyModal] = useState(false);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  const [openRegisterModal, setOpenRegisterModal] = useState(false);
  const [openForgotPasswordModal, setOpenForgotPasswordModal] = useState(false);
  const [openVerifyEmailModal, setOpenVerifyEmailModal] = useState(false);
  const [verificationEmail, setVerificationEmail] = useState("");

  // Optional convenience functions
  const openModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(true);
    if (type === "getDemo") setOpenGetDemoModal(true);
    if (type === "calendly") setOpenCalendlyModal(true);
    if (type === "login") setOpenLoginModal(true);
    if (type === "register") setOpenRegisterModal(true);
    if (type === "forgotPassword") setOpenForgotPasswordModal(true);
    if (type === "verifyEmail") setOpenVerifyEmailModal(true);
  }, []);

  const closeModal = useCallback((type) => {
    if (type === "ebook") setOpenEbookModal(false);
    if (type === "getDemo") setOpenGetDemoModal(false);
    if (type === "calendly") setOpenCalendlyModal(false);
    if (type === "login") setOpenLoginModal(false);
    if (type === "register") setOpenRegisterModal(false);
    if (type === "forgotPassword") setOpenForgotPasswordModal(false);
    if (type === "verifyEmail") setOpenVerifyEmailModal(false);
  }, []);

  const closeAll = useCallback(() => {
    setOpenEbookModal(false);
    setOpenGetDemoModal(false);
    setOpenCalendlyModal(false);
    setOpenLoginModal(false);
    setOpenRegisterModal(false);
    setOpenForgotPasswordModal(false);
    setOpenVerifyEmailModal(false);
    setIsModalOpen(false);
    setSelectedCard(null);
  }, []);

  const handleOpenModal = (id) => {
    const card = cards.find((c) => c.id === id);
    setSelectedCard(card);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedCard(null);
  };

  return {
    openEbookModal,
    setOpenEbookModal,
    openGetDemoModal,
    setOpenGetDemoModal,
    openCalendlyModal,
    setOpenCalendlyModal,
    handleOpenModal,
    handleCloseModal,
    isModalOpen,
    selectedCard,
    openModal,
    closeModal,
    closeAll,
    openLoginModal,
    setOpenLoginModal,
    openRegisterModal,
    setOpenRegisterModal,
    openForgotPasswordModal,
    setOpenForgotPasswordModal,
    openVerifyEmailModal,
    setOpenVerifyEmailModal,
    verificationEmail,
    setVerificationEmail,
  };
}
